import classNames from "classnames";
import styles from "./style.module.scss";
import { ReactNode, RefObject } from "react";
import XIcon from "assets/icons/XIcon";
interface RightSlideMenuProps {
  showRightSlideMenu: boolean;
  handleCloseIconClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  title: string;
  icon: ReactNode;
  children: ReactNode;
  containerRef: RefObject<HTMLDivElement>;
}

export const RightSlideMenu = ({
  showRightSlideMenu,
  handleCloseIconClick,
  title,
  icon,
  children,
  containerRef,
}: RightSlideMenuProps) => {
  const backgroundClassnames = classNames(styles.sharingMenuBackground, {
    [styles.sharingMenuBackgroundHidden]: !showRightSlideMenu,
  });
  const containerClassnames = classNames(styles.sharingMenuContainer, {
    [styles.sharingMenuContainerHidden]: !showRightSlideMenu,
  });
  return (
    <div className={backgroundClassnames}>
      <div ref={containerRef} className={containerClassnames}>
        <div className={styles.sharingMenuHeader}>
          {icon}
          {title}
          <div
            className={styles.closeIcon}
            onClick={handleCloseIconClick}
            data-testid="close-icon"
          >
            <XIcon />
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};
